"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./myAccountDropdown.scss");
var keys = {
  QuickOrderOverLay: 'my-account-dropdown'
};
var QuickOrderOverLay = function QuickOrderOverLay(props) {
  var children = props.children;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: "top-bar__nav__user__quick__order",
    "data-locator": "header-quick-order-user-dropdown-container"
  }, _react.default.createElement("div", {
    className: keys.QuickOrderOverLay,
    "data-locator": "header-quick-order-section"
  }, children)));
};
QuickOrderOverLay.defaultProps = {
  children: _react.default.createElement("div", null)
};
var _default = QuickOrderOverLay;
exports.default = _default;
module.exports = exports["default"];